import axios from "axios";
import { Toast } from "../../util/Toast";
import {
  GET_BAISHUN_GAMES,
  GET_BAISHUN_HISTORY,
  UPDATE_BAISHUN_GAME_STATUS,
} from "./type";

export const getBaishunGames = () => (dispatch) => {
  axios
    .get("/baishun/admin/games")
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: GET_BAISHUN_GAMES, payload: res.data.games || [] });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error);
      Toast("error", "Failed to load BAISHUN games");
    });
};

export const getBaishunHistory =
  ({
    page = 1,
    limit = 20,
    gameId = "ALL",
    startDate = "ALL",
    endDate = "ALL",
  } = {}) =>
  (dispatch) => {
    const query = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    });

    if (gameId && gameId !== "ALL") {
      query.set("gameId", String(gameId));
    }
    if (startDate && endDate && startDate !== "ALL" && endDate !== "ALL") {
      query.set("startDate", startDate);
      query.set("endDate", endDate);
    }

    axios
      .get(`/baishun/admin/history?${query.toString()}`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: GET_BAISHUN_HISTORY,
            payload: {
              history: res.data.history || [],
              stats: res.data.stats || {},
              pagination: res.data.pagination || {},
            },
          });
        } else {
          Toast("error", res.data.message);
        }
      })
      .catch((error) => {
        console.log("error", error);
        Toast("error", "Failed to load BAISHUN game history");
      });
  };

export const updateBaishunGameStatus = (gameId, isEnabled) => (dispatch) => {
  axios
    .post(`/baishun/admin/games/${gameId}`, { isEnabled })
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: UPDATE_BAISHUN_GAME_STATUS,
          payload: res.data.game,
        });
        Toast("success", res.data.message);
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error);
      Toast("error", "Failed to update BAISHUN game status");
    });
};
